import {
  APPLICATION_SUMMARY,
  VM_SUMMARY,
} from '@/components/Home/utils/custom.home.types.js';
import i18n from '@/plugins/i18n';

export const apmMetric = [
  {
    key: APPLICATION_SUMMARY,
    label: i18n.global.t('applicationSummary'),
  },
  {
    key: 'apm_load',
    label: 'Load',
  },
  {
    key: 'apm_error',
    label: 'Error',
  },
  {
    key: 'apm_resp',
    label: 'Response time ',
  },
  // {
  //   key: 'apm_resp_per',
  //   label: 'Percentile Response time '
  // },
];

export const browserMetric = [
  {
    key: APPLICATION_SUMMARY,
    label: i18n.global.t('applicationSummary'),
  },
  {
    key: 'browser_load',
    label: 'Load',
  },
  {
    key: 'browser_load_time',
    label: 'Load time',
  },
  {
    key: 'browser_error',
    label: 'Error',
  },
];

export const mobileMetric = [
  {
    key: APPLICATION_SUMMARY,
    label: i18n.global.t('applicationSummary'),
  },
  {
    key: 'mobile_app_crash_count',
    label: 'Number of Crashes',
  },
  {
    key: 'mobile_crash_affected_users',
    label: 'Crash Affected Users',
  },
  {
    key: 'mobile_crashes_by_os',
    label: 'Crashes By OS',
  },
  {
    key: 'mobile_crashes_by_app_version',
    label: 'Crashes By App Version',
  },
  {
    key: 'mobile_crashes_by_device',
    label: 'Crashes By Device(Top 5)',
  },
  {
    key: 'mobile_app_normal_count',
    label: 'Number of Requests',
  },
  {
    key: 'mobile_app_perf_response_time',
    label: 'HTTP Response Time',
  },
  {
    key: 'mobile_app_perf_error_sum',
    label: 'Error Rate',
  },
  {
    key: 'mobile_app_perf_user_impacted',
    label: 'Users Impacted by Errors',
  },
  {
    key: 'mobile_app_usage_active_session',
    label: 'Active Sessions',
  },
  {
    key: 'mobile_app_usage_app_launches',
    label: 'App Launches',
  },
  {
    key: 'mobile_app_usage_new_users',
    label: 'New Users',
  },
  {
    key: 'mobile_app_usage_by_os',
    label: 'Usage By OS',
  },
  {
    key: 'mobile_app_usage_by_device',
    label: 'Usage By Device(Top 5)',
  },
  {
    key: 'mobile_app_usage_by_app_version',
    label: 'App Version Distribution(Top 4)',
  },
];

export const vmMetrics = [
  {
    key: VM_SUMMARY,
    label: i18n.global.t('vmSummary'),
  },
];
